//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "RegisterType",
    methods:{
        indv() {
            this.$router.push({name: 'register', query: {role: 'users'}}).catch(err => {
                console.log(err)
            })
        },
        expt(){
            this.$router.push({name: 'register', query: {role: 'expert'}})
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/login/RegisterType.vue